/**
 * SDS Layer operations — ported from Designer
 * Copy, delete, move, align, transform, rotate, flip, opacity, visibility
 */

import { store } from '../core/store.js'
import { createLogger } from '../utils/logger.js'

const log = createLogger('layers')

function getSdk() {
  const sdk = store.getState('design.sdkInstance')
  return sdk?.sarto ? sdk : null
}

// ========== Basic operations ==========

export function copyLayer() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.copyLayer(); log.info('Layer copied') }
  catch (e) { console.warn('Failed to copy layer:', e) }
}

export function deleteLayer() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.deleteLayer(); log.info('Layer deleted') }
  catch (e) { console.warn('Failed to delete layer:', e) }
}

// ========== Layer order ==========

export function layerUp() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.moveLayerUp(); log.info('Layer up') }
  catch (e) { console.warn('Failed to move layer up:', e) }
}

export function layerDown() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.moveLayerDown(); log.info('Layer down') }
  catch (e) { console.warn('Failed to move layer down:', e) }
}

export function sendToTop() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.moveLayerToTop(); log.info('Send to top') }
  catch (e) { console.warn('Failed to send to top:', e) }
}

export function sendToBottom() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.moveLayerToBottom(); log.info('Send to bottom') }
  catch (e) { console.warn('Failed to send to bottom:', e) }
}

// ========== Alignment ==========

export function alignLeft() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerLeft(); log.info('Align left') }
  catch (e) { console.warn('Failed to align left:', e) }
}

export function alignRight() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerRight(); log.info('Align right') }
  catch (e) { console.warn('Failed to align right:', e) }
}

export function alignHCenter() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerCenter(); log.info('Align H center') }
  catch (e) { console.warn('Failed to align H center:', e) }
}

export function alignVCenter() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerMiddle(); log.info('Align V center') }
  catch (e) { console.warn('Failed to align V center:', e) }
}

export function alignTop() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerTop(); log.info('Align top') }
  catch (e) { console.warn('Failed to align top:', e) }
}

export function alignBottom() {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.alignLayerBottom(); log.info('Align bottom') }
  catch (e) { console.warn('Failed to align bottom:', e) }
}

// ========== Transformation ==========

export function zoom(type) {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.scaleLayer(type); log.info('Scale:', type) }
  catch (e) { console.warn('Failed to scale:', e) }
}

export function zoomIn() { zoom('in') }
export function zoomOut() { zoom('out') }

export function rotate(type) {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.rotateLayer(type); log.info('Rotate:', type) }
  catch (e) { console.warn('Failed to rotate:', e) }
}

export function rotateCounterclockwise() { rotate('counterclockwise') }
export function rotateClockwise() { rotate('clockwise') }

export function flip(type) {
  const sdk = getSdk()
  if (!sdk) return
  const sdkType = type === 'horizontal' ? 'x' : type === 'vertical' ? 'y' : type
  try { sdk.sarto.flipLayer(sdkType); log.info('Flip:', sdkType) }
  catch (e) { console.warn('Failed to flip:', e) }
}

export function flipHorizontal() { flip('x') }
export function flipVertical() { flip('y') }

// ========== Opacity ==========

export function setOpacity(value) {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.setLayerOpacity(value); log.info('Opacity set:', value) }
  catch (e) { console.warn('Failed to set opacity:', e) }
}

// ========== Visibility ==========

export function hideLayer(index) {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.hideLayer(index); log.info('Layer hidden:', index) }
  catch (e) { console.warn('Failed to hide layer:', e) }
}

export function showLayer(index) {
  const sdk = getSdk()
  if (!sdk) return
  try { sdk.sarto.showLayer(index); log.info('Layer shown:', index) }
  catch (e) { console.warn('Failed to show layer:', e) }
}

export default {
  copyLayer, deleteLayer,
  layerUp, layerDown, sendToTop, sendToBottom,
  alignLeft, alignRight, alignHCenter, alignVCenter, alignTop, alignBottom,
  zoom, zoomIn, zoomOut,
  rotate, rotateCounterclockwise, rotateClockwise,
  flip, flipHorizontal, flipVertical,
  setOpacity,
  hideLayer, showLayer,
}
